import './social_profile_view.js.coffee'
Namespace 'Customer.Users'

class Customer.Users.FacebookProfileView extends Customer.Users.SocialProfileView
  template: JST['backbone/templates/customer/users/facebook_profile']
  id: 'facebook-profile'

  render: ->
    @$el.html @template
      socialUser: @socialUser
    @trigger('updateName', @socialUser.values.name) if @socialUser.values.name
    @
